import HttpService from '../baseHttp';

// 角色管理分页列表
export const HttpGetRoleList = (data = {}) => HttpService.get('/api/v1/UcApprovalRole/selectByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 角色管理详情
export const HttpGetRoleDetail = (data = {}) => HttpService.get('/api/v1/UcApprovalRole/getById', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 角色管理列表
export const HttpGetAllRole = (data = {}) => HttpService.get('/api/v1/UcApprovalRole/selectAll', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 新增、修改角色
export const HttpAddRole = (data = {}, config) => HttpService.post('/api/v1/UcApprovalRole/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_UC, params: config } )
// 日志
export const HttpGetLog = (data = {}, config) => HttpService.post('/api/v1/UcOpRowLog/selectByPage', data, { baseURL: process.env.VUE_APP_APIURL_UC, params: config } )
export const HttpDeleteRole = (data = {}, config) => HttpService.post('/api/v1/UcApprovalRole/batchDel', data, { baseURL: process.env.VUE_APP_APIURL_UC, params: config } )

